import { render, staticRenderFns } from "./FetchExpress.vue?vue&type=template&id=2d66ad63&scoped=true&"
import script from "./FetchExpress.vue?vue&type=script&lang=js&"
export * from "./FetchExpress.vue?vue&type=script&lang=js&"
import style0 from "./FetchExpress.vue?vue&type=style&index=0&id=2d66ad63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d66ad63",
  null
  
)

export default component.exports